import { LOCAL_STORAGE_KEYS } from "@config/constant";

/** 读取 save_goal 草稿 ID（localStorage 优先于 tool args） */
export const getSaveGoalDraftIdFromStorage = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const value = localStorage.getItem(LOCAL_STORAGE_KEYS.GOAL_ID)?.trim();
  return value || null;
};

export const hasSaveGoalDraftIdInStorage = (): boolean =>
  getSaveGoalDraftIdFromStorage() != null;

/** 持久化 save_goal 草稿 ID（confirm-save 使用，不回传 Agent） */
export const persistSaveGoalDraftId = (goalId: string): void => {
  if (typeof window === "undefined") {
    return;
  }

  const trimmed = goalId.trim();
  if (!trimmed) {
    return;
  }

  localStorage.setItem(LOCAL_STORAGE_KEYS.GOAL_ID, trimmed);
};

/** 清除 save_goal 草稿 ID */
export const removeSaveGoalDraftIdFromStorage = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.removeItem(LOCAL_STORAGE_KEYS.GOAL_ID);
};
